export { TINInput } from './TINInput';
